import { generateAction } from '../builder'

const getCountries = generateAction('getCountries', 'admin/countries')
const getCountry = generateAction('getCountry', 'admin/countries/{id}')

export default {
  getCountries,
  getCountry,
}
